<template>
  <div class="mb-4">
    <div class="w-full mb-4">
      <strong>{{ name }}</strong>
    </div>
    <div class="w-full">
      <vs-switch 
        v-model="value"
        @change="updateValue"
        :disabled="disabled"
      >
        <span slot="on">Sim</span>
        <span slot="off">Não</span>
      </vs-switch>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'BooleanField',
    inject: ['$validator'],
    props: {
      index: {
        type: Number,
        required: true
      },
      items: {
        type: Array,
        required: false
      },
      description: {
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    data() {
      return {
        value: false
      }
    },
    computed:  {
      name(){
        if ( !this.description || this.description.description == ''){
          return;
        } 
        else if ( this.description.description ){
          return this.description.description;
        }
        return this.description;
      }
    },
    methods: {
      updateValue() {
        this.$emit('valueChanged', this.index, 0, this.value)
      }
    },
    created() {
      if (!this.items) { return;}
      this.items.forEach((item) => {
        if(!item.value || item.value.toLowerCase() == 'false'){ return; }
        this.value = true
      })
    }
  }
</script>
